module.exports = __webpack_public_path__ + "static/media/Logo_Origo_Transp_TexteClair_ras_3_5x1_1.d7b8e97a.png";